import { Task } from '../../types';

export type ReviewSortMode = 'age' | 'round';

function reviewAgeTime(task: Task): number {
  return (task.submittedAt ?? task.updatedAt ?? task.createdAt).getTime();
}

function reviewRoundOrder(task: Task): number {
  return Math.max(1, task.reviewRound);
}

export function sortReviewTasks(tasks: Task[], sortMode: ReviewSortMode): Task[] {
  return [...tasks].sort((a, b) => {
    const aRound = reviewRoundOrder(a);
    const bRound = reviewRoundOrder(b);
    if (sortMode === 'round' && aRound !== bRound) {
      return aRound - bRound;
    }
    const ageDiff = reviewAgeTime(a) - reviewAgeTime(b);
    if (ageDiff !== 0) return ageDiff;
    return a.id.localeCompare(b.id);
  });
}
